import React, { useEffect } from 'react';

// components
import { HeaderV2 } from '@tajawal/ct-web-myaccount.app-shared/lib';
import { CompactFooter } from '@tajawal/ct-web-footer-compact';
import OverlayLoader from '@/app-common/components/OverlayLoader';

// stores
import type { Store } from '@/stores';

// hooks
import useStateOfAuth from '@/hooks/useStateOfAuth';

// styles
import Styles from './PageLayout.styled';

// utils
import usePageLayout from '@/hooks/usePageLayout';
import useStateOfUI from '@/hooks/useStateOfUI';
import Loader from '../Loader/Loader';
import dynamic from 'next/dynamic';
import { usePartnerReferer } from '@/hooks/usePartnerReferer';
import { useRouter } from 'next/router';

type ComponentLayoutProps = {
  children: JSX.Element;
  isMobile: boolean;
  store: Store;
};

const DashboardDrawer = dynamic<any>(
  () => import('@tajawal/ct-web-myaccount.app-shared/lib').then((mod) => mod.DashboardDrawerV2),
  { ssr: false }
);

function PageLayout({ children, isMobile, store }: ComponentLayoutProps) {
  const { query } = useRouter();
  const { isUser } = useStateOfAuth(store);
  const { isDashboardDrawerOpen, setDashboardDrawerOpen, isPageLoading } = useStateOfUI(store);
  const { configStore, currencyStore, userStore, currencyList, loginStore, registerStore, countryStore } =
    usePageLayout(store);
  const partnerReferer = usePartnerReferer();

  useEffect(() => {
    if (!isUser) {
      countryStore.fetch();
    }
  }, [isUser]);

  if (isMobile) {
    return (
      <>
        {isPageLoading && <OverlayLoader />}
        {children}
      </>
    );
  }

  return (
    <Styles.PageLayout>
      {isPageLoading && <OverlayLoader />}
      <HeaderV2
        configStore={configStore}
        currencyStore={currencyStore}
        isLoggedIn={isUser}
        query={query}
        currencyList={currencyList}
        isFullHeader={false}
        userStore={userStore}
        isFixed
        onOpenDrawer={() => setDashboardDrawerOpen(true)}
      />

      <Loader shouldLoad={isDashboardDrawerOpen}>
        <DashboardDrawer
          isLoggedIn={isUser}
          userStore={userStore}
          loginStore={loginStore}
          registerStore={registerStore}
          countryStore={countryStore}
          config={configStore}
          currencyStore={currencyStore}
          isOpen={isDashboardDrawerOpen}
          isDrawer
          onClose={() => setDashboardDrawerOpen(false)}
        />
      </Loader>
      <Styles.PageWrapper>{children}</Styles.PageWrapper>

      <CompactFooter configStore={configStore} store={store} partnerReferrer={partnerReferer} config={global.config} />
    </Styles.PageLayout>
  );
}

export default PageLayout;
